import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";     // Hamburger Icon
import { IoMdClose } from "react-icons/io"; // Cancel (X) Icon
import "./navbar.css";
import logo from "../images/Eaekanem-logo.jpg";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container container">
        {/* Logo */}
        <Link to="/" className="nav-logo">
          <img className="logo" src={logo} alt="realestate abuja" />
        </Link>

        {/* Toggle Icon */}
        <div className="nav-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <IoMdClose className="icon" /> : <FaBars className="icon" />}
        </div>

        {/* Menu Links */}
        <ul className={isOpen ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setIsOpen(false)}>HOME</Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link" onClick={() => setIsOpen(false)}>ABOUT US</Link>
          </li>
          <li className="nav-item">
            <Link to="/our-listing" className="nav-link" onClick={() => setIsOpen(false)}>OUR LISTING</Link>
          </li>
          <li className="nav-item">
            <Link to="/our-business" className="nav-link" onClick={() => setIsOpen(false)}>OUR BUSINESS</Link>
          </li>
          <li className="nav-item">
            <Link to="/sell-with-us" className="nav-link" onClick={() => setIsOpen(false)}>SELL WITH US</Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link" onClick={() => setIsOpen(false)}>CONTACT</Link>
          </li>
          <li className="nav-item">
            <Link to="/talentcommunity" className="nav-link" onClick={() => setIsOpen(false)}>JOIN OUR TALENT COMMUNITY</Link>
          </li>
          <li className="nav-item">
            <Link to="/giving-back" className="nav-link" onClick={() => setIsOpen(false)}>GIVING BACK</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
